const ObfuscatedEmailAddress = (value) => {
  return (
    <a href="mailto:&#104;&#97;&#110;&#115;&#64;&#104;&#97;&#110;&#115;&#118;&#101;&#114;&#104;&#101;&#105;&#106;&#107;&#101;&#46;&#99;&#111;&#109;">
      &#104;&#97;&#110;&#115;&#64;&#104;&#97;&#110;&#115;&#118;&#101;&#114;&#104;&#101;&#105;&#106;&#107;&#101;&#46;&#99;&#111;&#109;
    </a>
  );
};

export default ObfuscatedEmailAddress